import { ENVIRONMENT_LABEL_KEY, UNIT_ID_LABEL_KEY } from 'src/common/consts/platformConfigConsts';

export const isCoreLabel = (labelKey: string): boolean => {
	return labelKey === UNIT_ID_LABEL_KEY || labelKey === ENVIRONMENT_LABEL_KEY;
};
